import React from "react";
import PdfPage from "../components/PdfPage";

const SecpInvestorGuide = () => {
  return (
    <main>
      <PdfPage
        h2={"Secp Investor Guide"}
        img={"https://api.orbitsecurities.com.pk/media/cms/images/secp-logo.jpg"}
        pdf1={"https://api.orbitsecurities.com.pk/media/cms/documents/secp-investor-guide-english.pdf"}
        pdf1Text={"Download  In English"}
        pdf2={"https://api.orbitsecurities.com.pk/media/cms/documents/secp-investor-guide-urdu.pdf"}
        pdf2Text={"Download In Urdu"}
      />
    </main>
  );
};

export default SecpInvestorGuide;
